import React from 'react';

import { motion } from 'framer-motion';

import { CONTACT_CONFIG } from '@/config';
import { Icon } from '@/utils/icons';

const WhatsAppButton: React.FC = () => {
  const normalizedPhone = CONTACT_CONFIG.phone.replace(/[^\d]/g, '');

  const defaultMessage =
    "Hi! I'm interested in premium handcrafted soft toys from BST - The Soft Studio. Could you please help me?";
  const whatsappUrl = `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{
        scale: 1,
        opacity: 1,
        y: [0, -6, 0],
      }}
      transition={{
        scale: { type: 'spring', stiffness: 260, damping: 20 },
        y: {
          repeat: Infinity,
          duration: 3,
          ease: 'easeInOut',
        },
      }}
      whileHover={{
        scale: 1.12,
        rotate: 5,
        boxShadow: '0 12px 40px rgba(37, 211, 102, 0.5)',
      }}
      whileTap={{ scale: 0.92 }}
      className="fixed right-4 bottom-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-tr from-[#25D366] to-[#128C7E] text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-shadow duration-300 focus:ring-4 focus:ring-green-300 focus:outline-none dark:focus:ring-green-900">
      <Icon name="Whatsapp" size={28} />
    </motion.a>
  );
};

export default React.memo(WhatsAppButton);
